import React from 'react';
import PropTypes from 'prop-types';

const ValidationView = ({ errorMessages, closeFunction }) => {
  if (errorMessages.length > 0) {
    return (
      <div className="adv-workflow-validation">
        <div className="adv-workflow-validation-content">
          <div className="adv-workflow-validation-exclamation-mark">!</div>
          {errorMessages.map(errorMessage => (
            <div
              className={
                errorMessages.length > 1
                  ? 'adv-workflow-validation-content-item-multiple'
                  : 'adv-workflow-validation-content-item-single'
              }
              key={errorMessage}
              aria-live="assertive"
              role="alert"
            >
              {errorMessage}
            </div>
          ))}
        </div>
        {closeFunction && (
          <span
            role="button"
            tabIndex="0"
            onKeyDown={() => {}}
            onClick={closeFunction}
            className="adv-workflow-validation-content-item-close"
          >
            +
          </span>
        )}
      </div>
    );
  }
  return null;
};

ValidationView.defaultProps = {
  errorMessages: [],
  closeFunction: null,
};

ValidationView.propTypes = {
  errorMessages: PropTypes.arrayOf(PropTypes.string.isRequired),
  closeFunction: PropTypes.func,
};

export default ValidationView;
